<template>
  <v-form lazy-validation @submit.prevent="onSubmit" ref="form">
    <v-card-text>
      <v-text-field
        v-if="!showNewPassword"
        id="password"
        label="Nova Senha"
        name="password"
        type="password"
        v-model="payload.senha"
        :rules="passwordRules"
        required
        background-color="white"
        solo
        append-icon="mdi-eye-off"
        @click:append="showNewPassword = true"
      ></v-text-field>
      <v-text-field
        v-if="showNewPassword"
        id="password"
        label="Nova Senha"
        name="password"
        type="text"
        v-model="payload.senha"
        :rules="passwordRules"
        required
        background-color="white"
        solo
        append-icon="mdi-eye"
        @click:append="showNewPassword = false"
      ></v-text-field>

      <v-text-field
        v-if="!showConfirmPassword"
        id="confirm-password"
        label="Confirme a senha"
        name="confirm-password"
        type="password"
        v-model="payload.confirmacaoSenha"
        :rules="confirmPasswordRules"
        required
        append-icon="mdi-eye-off"
        background-color="white"
        solo
        @click:append="showConfirmPassword = true"
      ></v-text-field>
      <v-text-field
        v-if="showConfirmPassword"
        id="confirm-password"
        label="Confirme a senha"
        name="confirm-password"
        type="text"
        v-model="payload.confirmacaoSenha"
        :rules="confirmPasswordRules"
        required
        append-icon="mdi-eye"
        background-color="white"
        solo
        @click:append="showConfirmPassword = false"
      ></v-text-field>

      <div class="mt-5" :style="{ color: corTexto }">
        <div
          v-for="(especificacao, index) in especificacaoSenha"
          :key="index"
          :class="errosSenha.includes(especificacao.name) ? 'falta' : ''"
        >
          - {{ especificacao.title }}
        </div>
      </div>
    </v-card-text>
    <v-card-actions>
      <v-row>
        <v-col>
          <div class="text-center">
            <v-btn color="secondary" type="submit"> Trocar Senha </v-btn>
          </div>
        </v-col>
      </v-row>
    </v-card-actions>
  </v-form>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { userAPI } from "@/modules/user";
import {
  regexSenhaQuebrado,
  especificacaoLabels,
} from "@/helpers/senhaEspecificacao";
import Swal from "sweetalert2";
import verificarTonalidadeCor from "@/helpers/verificarTonalidadeCor";
import { atualUfDefinition } from "@/helpers/utils";

export default {
  mounted() {
    // this.verificarToken();
  },
  computed: {
    ...mapGetters(["isSala", "logos"]),
    corTexto() {
      if (verificarTonalidadeCor(atualUfDefinition.corPrimaria))
        return "rgba(0, 0, 0, 0.6)";

      return "#fff";
    },
  },
  data() {
    return {
      payload: {
        tokenRecuperacao: this.$route.params.token,
      },
      especificacaoSenha: especificacaoLabels,
      errosSenha: [],
      showNewPassword: false,
      showConfirmPassword: false,
      regexSenhaQuebrado: regexSenhaQuebrado,
      confirmPasswordRules: [
        (v) => !!v || "O campo confirmação de senha é obrigatório",
        (v) => {
          if (v !== this.payload.senha) {
            return "As senhas devem ser iguais";
          }
          return true;
        },
      ],
      passwordRules: [
        (v) => !!v || "O campo nova senha é obrigatório",
        (v) => {
          if (v && !this.regexSenhaQuebrado.totalRegex.test(v)) {
            this.errosSenha = [];
            !this.regexSenhaQuebrado.letraMinuscula.test(v) &&
              this.errosSenha.push("minuscula");
            !this.regexSenhaQuebrado.letraMaiuscula.test(v) &&
              this.errosSenha.push("maiuscula");
            !this.regexSenhaQuebrado.numero.test(v) &&
              this.errosSenha.push("numero");
            !this.regexSenhaQuebrado.especial.test(v) &&
              this.errosSenha.push("especial");
            v.length < 8 && this.errosSenha.push("caracteres");

            return "Senha fraca";
          }
          this.errosSenha = [];
          return true;
        },
      ],
      userRules: [(v) => !!v || "O campo usuário é obrigatório"],
      logo: this.$store.state.logo,
    };
  },
  methods: {
    ...mapActions(["setLoading"]),
    verificarToken() {
      userAPI
        .verificarToken(this.$route.params.token)
        .then((_) => {})
        .catch((err) => {
          Swal.fire({
            title: "Atenção!",
            text: err.response.data,
            confirmButtonText: "Entendi",
          }).then((result) => {
            this.$router.push("/auth/login");
          });
        });
    },
    async check() {
      const isValid = await this.$refs.form.validate();
      return isValid;
    },
    async onSubmit() {
      var isValid = await this.check();
      if (!isValid) return;
      this.setLoading(true);
      userAPI
        .trocarSenha(this.payload)
        .then((resp) => {
          if (!resp.data) {
            this.setLoading(false);
            this.$notification.error("Token inválido!", { timer: 10 });
          } else {
            this.setLoading(false);
            this.$router.push("/auth/login");
          }
        })
        .catch((resp) => {
          this.setLoading(false);
          this.$notification.error("Erro ao recuperar senha!", { timer: 10 });
        });
    },
  },
};
</script>
<style lang="scss" scoped>
.falta {
  color: red;
}
</style>

<style lang="scss">
@import "../style.scss";
</style>
